import React, { useState, useEffect } from "react";

export default function CookieWrapper() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const cookieAccepted = localStorage.getItem("cookieConsent");
    if (!cookieAccepted) {
      const showCookieNotice = () => setVisible(true);
      const timer = window.setTimeout(showCookieNotice, 8000);
      return () => window.clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "accepted");
    console.log("Cookies accepted");
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem("cookieConsent", "declined");
    console.log("Cookies declined");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookiewrapper">
      <div className="heading">About cookies on this site</div>
      <div className="data">
        <p>
          We use cookies to collect and analyse information on site performance
          and usage, to provide social media features and to enhance and
          customise content.
        </p>
      </div>

      <div className="buttons">
        <button className="theme-btn dark-btn" onClick={handleAccept}>
          Accept
        </button>
        <button className="theme-btn" onClick={handleDecline}>
          Dismiss
        </button>
      </div>
    </div>
  );
}
